<template>
  <div class="ruKuZuoyeWarp app-container">
    <div class="ruKuZuoyeWarp-body">
      <!-- 查询条件 -->
      <div ref="searchBox" class="formBox margbot">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="90px" size="mini">
          <div class="formItemBox">
          <el-form-item label="出库单号:">
            <el-input class="ipt" v-model="formData.outstockNo" maxlength="50" placeholder="请输入出库单号" size="mini"
              ></el-input>
          </el-form-item>
          <el-form-item label="创建时间:">
            <div style="display: flex;">
            <el-date-picker v-model="formData.dateStart" size="mini" type="date" placeholder="请选择"
              value-format="yyyy-MM-dd"></el-date-picker>
            -
            <el-date-picker v-model="formData.dateEnd" size="mini" placeholder="请选择" type="date"
              value-format="yyyy-MM-dd"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select v-model="formData.primaryCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="formData.customerTaxId" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName"
                :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号:">
            <el-input class="ipt" v-model="formData.outstockPlateNumber" maxlength="10" placeholder="请输入车牌号" size="mini"
             ></el-input>
          </el-form-item>
          <el-form-item label="提货单号:">
            <el-input class="ipt" v-model="formData.billNo" maxlength="50" placeholder="请输入提货单号" size="mini"
              ></el-input>
          </el-form-item>
          <el-form-item label="客户单号:">
            <el-input class="ipt" v-model="formData.outBillNo" maxlength="50" placeholder="请输入客户单号" size="mini"
              ></el-input>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="formData.productType" clearable placeholder="请选择货物类型" filterable size="mini">
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productName"
                :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:" >
            <el-input v-model="formData.steelMillName" maxlength="10" placeholder="请输入产地"
              size="mini"></el-input>
          </el-form-item>
          <el-form-item label="材质:">
            <el-input v-model="formData.model" maxlength="10" placeholder="请输入材质"
              size="mini"></el-input>
          </el-form-item>
          <el-form-item label="规格:" >
            <el-input v-model="formData.specification" maxlength="10" placeholder="请输入规格"
              size="mini"></el-input>
          </el-form-item>
          <!-- <el-form-item label="提货客户:">
            <el-select v-model="formData.pickupCustomerTaxId" size="mini" placeholder="请选择提货客户" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
            </el-select>
          </el-form-item> -->
         </div>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" btnCode="00cP006B001" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP006B002" v-if="btnFlg[1]">重置</el-button>
            <el-button type="primary" size="mini" @click="xinzeng" btnCode="00cP006B003" v-if="btnFlg[2]">新增</el-button>
            <el-button type="primary" size="mini" @click="xiugai" btnCode="00cP006B004" v-if="btnFlg[3]">修改</el-button>
            <el-button type="primary" size="mini" @click="shanchu" btnCode="00cP006B005" v-if="btnFlg[4]">删除</el-button>
            <el-button type="primary" size="mini" @click="dayin" btnCode="00cP006B006" v-if="btnFlg[5]">打印</el-button>
            <el-button type="primary" size="mini" @click="daochu" btnCode="00cP006B007" v-if="btnFlg[6]">导出</el-button>
          </el-form-item>
           <el-form-item>
             <span style="margin-right:20px;">总吨数：<span style="color: red">{{ Number(allWeightMaster).toFixed(4)
          }}</span>吨</span>
          <span>总件数：<span style="color: red">{{ allNumberMaster }}</span>件</span>
           </el-form-item>
        </el-form>

      </div>
      <!-- 表格 -->
      <div :style="{ height: h }">
        <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"
          style="width: 100%" class="tableComent" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          highlight-current-row @row-click="dianjixuanzhong">
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column align="center" label="操作" width="120">
            <template v-slot="scope">
              <el-button type="text" @click="lookGoods(scope.row)" size="mini" v-show="scope.row.path">提货函</el-button>
              <el-button type="text" @click="lookMessage(scope.row)" size="mini">人车信息</el-button>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockNo" label="出库单号" align="center"
            width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
            width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center"
            width="220"></el-table-column>
          <!-- <el-table-column :show-overflow-tooltip="true" prop="pickupCustomerName" label="提货客户" width="230px" ></el-table-column> -->
          <el-table-column :show-overflow-tooltip="true" prop="outBillNo" label="客户单号" align="center"
            width="150"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="车牌号" align="center"
            width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createTime" label="创建时间" align="center" width="170"
            :formatter="dateTimeFormat"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机姓名" align="center"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" align="center"
            width="115"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="司机身份证号" align="center"
            width="170"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="sourceName" label="数据来源" align="center"
            width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="billNo" label="提货单号" align="center"
            width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="miniBillNo" label="预提单号" align="center"
            width="220"></el-table-column>
          <el-table-column prop="carHoldFalg" label="是否扣车" align="center" width="100">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.carHoldFalg == '0'">不扣</span>
                <span v-else>扣车</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pickupCustomerName" label="提货客户" width="180px"></el-table-column>

          <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" align="center"
            width="220"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center"
            width="130"></el-table-column>
        </el-table>
      </div>
      <div class="pags" style="text-align: right">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
          :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
      </div>
      <div class="market_out">
        <div class="detailsTitle">
          <h4>货物详情</h4>
        </div>
        <!--货物详情-->
        <div>
          <div ref="searchBox2" style="margin-top: 5px;margin-bottom:5px;margin-left:10px;">
            <el-button type="primary" size="mini" @click="xc" btnCode="00cP006B008" v-if="btnFlg[7]">确认出库</el-button>
            <el-button type="primary" size="mini" @click="weighClick" btnCode="00cP006B009"
              v-if="btnFlg[8]">过磅</el-button>
            <el-button type="primary" size="mini" @click="heBangClick" btnCode="00cP006B00A"
              v-if='heBangDisabled && btnFlg[9]'>合磅</el-button>
            <span>
              总吨数:
              <span style="color: red">{{ totalAllWeight }}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ totalNumber }}</span> &nbsp;件
            </span>
          </div>
          <!--详情表格-->
          <div class="ruKuZuoyeWarp-body-detailsTab">
            <div class="ruKuZuoyeWarp-body-table" :style="{ height: detailsH }">
              <el-table height="100%" size="mini" ref="tabref" :data="detailsData" style="width: 100%" :header-cell-style="{
                background: '#F5F5F5',
                color: 'black',
              }" highlight-current-row @row-click="dianjixuanzhongXQ" border center bordersize="mini">
                <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
                <el-table-column align="center" label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button type="text" @click="lookBD(scope.row)" size="mini"
                      v-if="Number(scope.row.weighingWeight / 1) > 0">磅单</el-button>
                    <el-button type="text" @click="guoBangClick(scope.row)" size="mini">过磅记录</el-button>
                  </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productName" label="货物类型" align="center"
                  width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="placeOfOrigin" label="产地" align="center"
                  width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"
                  width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"
                  width="150"></el-table-column>
                <el-table-column prop="vehicleNumber" label="车船号" width="120"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center"
                  width="130"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"
                  width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center"
                  width="150"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重(吨)" align="center"
                  width="100"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingWeight" label="过磅净重（吨）" align="center"
                  width="150"></el-table-column>
                <el-table-column prop="shipForecastNo" label="预报编号" width="260"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="weighingDate" label="过磅时间" align="center" width="180"
                  :formatter="dateTimeFormat"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="sceneUser" label="现场人员" align="center"
                  width="200"></el-table-column>
              </el-table>
            </div>
            <!--分页-->
            <div class="pags" style="text-align: right">
              <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo"
                :page-size="pageInfoXQ.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
                layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ"
                :total="totalXQ"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- dialogs -->
    <!-- 新增出库计划 -->
    <chuKu-plan-dialog v-if="addPlanBillVisible" :addPlanBillVisible.sync="addPlanBillVisible" :title="xzTitle"
      @chaxun='chaxun' :xztableData="xztableData" :xiugaiObj="xiugaiObj" :RKData.sync='RKData'></chuKu-plan-dialog>
    <!-- 修改出库计划 -->
    <change-chuKu-plan v-if="changePlanBillVisible" :changePlanBillVisible.sync="changePlanBillVisible"
      :xztableData="xztableData" :xiugaiObj="xiugaiObj"
      :outstockPlateNumber='formData.outstockPlateNumber'></change-chuKu-plan>
    <confirm-Out-Stock v-if="xcVisible" :xcVisible.sync='xcVisible' :outstockId="outstockId"></confirm-Out-Stock>
    <!-- 人车信息 -->
    <rcDialog v-if="RCVisible" :RCVisible.sync='RCVisible' :identityNo="identityNo" :vhcNo="vhcNo"
      :driverName="driverName" :telephone="telephone"></rcDialog>
    <!-- 山西美景/安阳/确认出库 -->
    <confirm-delivery v-if="confirmVisible" :confirmVisible.sync='confirmVisible' :outstockId="outstockId"
      :deliveryObj="deliveryObj"></confirm-delivery>
    <!-- 查看磅单 -->
    <bdDialog v-if="BDVisible" :BDVisible.sync='BDVisible' :outstockSummaryId="outstockSummaryId"></bdDialog>
    <!-- 过磅 -->
    <weigh-dialog v-if="weighVisible" :weighVisible.sync='weighVisible' :outstockId="outstockId"
      :GBoutstockPlateNumber="GBoutstockPlateNumber"></weigh-dialog>
    <!-- 合磅 -->
    <heBang-dialog v-if="heBangVisible" :heBangVisible.sync='heBangVisible' :outstockId="outstockId"
      :GBoutstockPlateNumber="GBoutstockPlateNumber"></heBang-dialog>
    <!-- 过磅记录 -->
    <gBJiLu-dialog v-if="guoBangVisible" :guoBangVisible.sync='guoBangVisible'
      :outstockSummaryId="outstockSummaryId"></gBJiLu-dialog>
  </div>
</template>

<script>
import {
  getOutstockMasterListJanFa, // 列表
  JfgetOutstockSummaryListJanFa, // 子表
  getRelationCustomer,
  getUsersByTenantCode,
  JfdelTEmptyOutstockMasterJanFa, // 删除
  zidian,
  getWeighingMethodList,
  getVirtualBalingList,
  getEmptyWeightInfoListForOutstockId
} from '@/api/wms-stock'
import { getSBillFileUrl } from '@/api/soc-stock'

import {
  dateTimeFormat
} from '@/utils/util'
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import chuKuPlanDialog from './chuKuPlanDialog.vue'
import changeChuKuPlan from './changeChuKuPlan.vue'
import confirmOutStock from './confirmOutStock.vue'
import confirmDelivery from './confirmDelivery.vue'
import { exportExcel } from '@/utils/fileDown.js'
import rcDialog from '../../yycRuKu/yycChuanYun/dialog/RCdialog.vue'
import bdDialog from '../../yycRuKu/yycChuanYun/dialog/BDImg.vue'
import weighDialog from './weighDialog.vue'
import heBangDialog from './heBangDialog.vue'
import gBJiLuDialog from '../gBJiLuDialog.vue'
export default {
  components: { chuKuPlanDialog, confirmOutStock, changeChuKuPlan, rcDialog, confirmDelivery, bdDialog, weighDialog, heBangDialog, gBJiLuDialog },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      btnFlg: [],
      btnIdArr: [
        '00cP006B001',
        '00cP006B002',
        '00cP006B003',
        '00cP006B004',
        '00cP006B005',
        '00cP006B006',
        '00cP006B007',
        '00cP006B008',
        '00cP006B009',
        '00cP006B00A'
      ],
      formData: {
        steelMillName: '',
        model: '',
        specification: '',
        outstockPlateNumber: '',
        billNo: '',
        primaryCustomerName: '',
        customerName: '',
        dateStart: '',
        dateEnd: '',
        driverName: '',
        customerTaxId: '',
        primaryCustomerTaxId: '',
        instockNo: '',
        pickupCustomerTaxId: ''
      },
      HwTypeData: [],
      totalXQ: 0,
      pageInfo: {
        pageNo: 1,
        pageSize: 20,
        outstockStatus: 0
      },
      pageInfoXQ: {
        pageSize: 20,
        pageNo: 1
      },
      total: 0,
      detailsData: [], // 详情数据
      RKData: [], //
      tableData: [],
      totalAllWeight: '',
      totalNumber: '',
      detailsH: '200px',
      h: '500px',
      xuanzhongArr: null,
      xuanzhongArrXQ: null,
      xcLoading: false,
      inWeighingMethod: '',
      addPlanBillVisible: false,
      xzTitle: '新增出库计划',
      xztableData: [],
      productTypeData: [],
      xcVisible: false,
      xiugaiObj: {},
      xieCheTable: [],
      changePlanBillVisible: false,
      chepai: '',
      outstockId: '',
      RCVisible: false,
      vhcNo: '',
      identityNo: '',
      telephone: '',
      driverName: '',
      allWeightMaster: 0,
      allNumberMaster: 0,
      confirmVisible: false,
      BDVisible: false,
      outstockSummaryId: '',
      deliveryObj: {},
      weighVisible: false,
      heBangVisible: false,
      heBangDisabled: false,
      guoBangVisible: false,
      GBoutstockPlateNumber: ''
    }
  },
  methods: {
    // 下拉框
    getVirtualBalingLists () {
      getVirtualBalingList()
        .then(res => {
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          console.log(this.productTypeData, 'this.productTypeData')
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 点击过磅记录
    guoBangClick (row) {
      this.guoBangVisible = true
      this.outstockSummaryId = row.outstockSummaryId
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/tEmptyForJanFa/exportEmptyOutstockMasterListJanFa',
        { ...this.formData, outstockStatus: '0' },
        '出库单据表'
      )
    },
    // 人车信息
    lookMessage (row) {
      this.RCVisible = true
      this.identityNo = row.idNumber
      this.vhcNo = row.outstockPlateNumber
      this.telephone = row.telephone
      this.driverName = row.driverName
    },
    // 提货函
    lookGoods (row) {
      if (row.path) {
        let formData = new FormData()
        formData.append('url', row.path)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            name: 'Pdf',
            query: { path: res }
          })
        })
      }
    },
    // 磅单
    lookBD (row) {
      this.BDVisible = true
      this.outstockSummaryId = row.outstockSummaryId
    },
    xc () {
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.xcVisible = true
      this.outstockId = this.xuanzhongArr.outstockId
    },
    confirmClick () {
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
      } else if (this.xuanzhongArr.ext1 == '1') {
        this.confirmVisible = true
        this.deliveryObj = this.detailsData[0]
        this.outstockId = this.xuanzhongArr.outstockId
      } else {
        DonMessage.error('只有出仓提单页面下发的出库计划可以确认出库')
      }
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.JfgetThreadDetailExpLists()
    },
    xinzeng () {
      this.addPlanBillVisible = true
      this.xzTitle = '新增出库计划'
    },
    xiugai () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.changePlanBillVisible = true
      this.xiugaiObj = this.xuanzhongArr
      this.xztableData = this.detailsData
    },
    shanchu () {
      if (this.tableData.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        JfdelTEmptyOutstockMasterJanFa({
          outstockId: this.xuanzhongArr.outstockId
        })
          .then(res => {
            DonMessage.success('删除成功')
            that.chaxun()
          })
          .catch(error => {
            DonMessage.error(error.message)
          })
      })
    },
    chaxun () {
      if (this.formData.dateStart) {
        this.formData.dateStart = this.formData.dateStart + ' 00:00:00'
      }
      if (this.formData.dateEnd) {
        this.formData.dateEnd = this.formData.dateEnd + ' 23:59:59'
      }
      getOutstockMasterListJanFa({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        outstockStatus: this.pageInfo.outstockStatus,
        outstockNo: this.formData.outstockNo,
        dateStart: this.formData.dateStart,
        dateEnd: this.formData.dateEnd,
        primaryCustomerTaxId: this.formData.primaryCustomerTaxId,
        customerTaxId: this.formData.customerTaxId,
        outstockPlateNumber: this.formData.outstockPlateNumber,
        billNo: this.formData.billNo,
        outBillNo: this.formData.outBillNo,
        productType: this.formData.productType,
        model: this.formData.model,
        specification: this.formData.specification,
        steelMillName: this.formData.steelMillName,
        // formData.productType
        pickupCustomerTaxId: this.formData.pickupCustomerTaxId
      })
        .then(res => {
          this.tableData = res.pageInfo.list
          if (res.pageInfo.list.length) {
            this.xuanzhongArr = res.pageInfo.list[0]
            this.$nextTick(() => {
              this.$refs.tabref1.setCurrentRow(res.pageInfo.list[0])
            })
            this.JfgetThreadDetailExpLists()
          } else {
            this.detailsData = []
            this.totalAllWeight = 0
            this.totalNumber = 0
            this.totalXQ = 0
          }
          this.allWeightMaster = res.all.allWeight
          this.allNumberMaster = res.all.allNumber
          this.total = res.pageInfo.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chongzhi () {
      this.formData.outstockPlateNumber = ''
      this.formData.billNo = ''
      this.formData.outstockNo = ''
      this.formData.dateStart = ''
      this.formData.dateEnd = ''
      this.formData.primaryCustomerTaxId = ''
      this.formData.customerTaxId = ''
      this.formData.outstockPlateNumber = ''
      this.formData.outBillNo = ''
      this.formData.productType = ''
      this.formData.model = ''
      this.formData.specification = ''
      this.formData.steelMillName = ''
      this.formData.pickupCustomerTaxId = ''
      this.chaxun()
    },
    dayin () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        }
        )
        return
      }
      this.$router.push({
        path: '/yycZhuangCheDan',
        query: {
          id: this.xuanzhongArr.outstockId
        }
      })
    },

    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.JfgetThreadDetailExpLists()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.JfgetThreadDetailExpLists()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 货物详情
    JfgetThreadDetailExpLists () {
      JfgetOutstockSummaryListJanFa(
        {
          outstockId: this.xuanzhongArr.outstockId,
          ...this.pageInfoXQ
        }
      )
        .then(res => {
          this.detailsData = res.pageInfo.list
          this.totalXQ = res.pageInfo.total
          this.xuanzhongArrXQ = res.pageInfo.list[0]
          this.totalAllWeight = res.all.allWeight
          this.totalNumber = res.all.allNumber
          this.$nextTick(() => {
            this.$refs.tabref.setCurrentRow(res.pageInfo.list[0])
          })
          // 货物信息有且只有皮重时才能点击合磅
          // 有皮重且没有净重  可点合磅
          if (this.detailsData.length != 0) {
            getEmptyWeightInfoListForOutstockId({
              outstockId: this.xuanzhongArr.outstockId
            })
              .then(res => {
                if (res.length != 0) {
                  // 任务8410 修改合磅显示逻辑
                  // 有皮重，没有毛重，显示
                  // 有皮重，所有规格都有毛重，显示
                  // 有皮重，部分规格有毛重，不显示
                  // 没有有皮重，不显示
                  // tareWeight  皮重   weightingWeight 毛重
                  let flagA = res.every(item => !!item.tareWeight && !item.weightingWeight)
                  let flagB = res.every(item => !!item.tareWeight && !!item.weightingWeight)
                  console.log(flagB, 'flagB')
                  console.log(flagA, 'flagA')
                  if (flagA || flagB) {
                    this.heBangDisabled = true
                  } else {
                    this.heBangDisabled = false
                  }
                } else {
                  this.heBangDisabled = false
                }
              })
              .catch(err => {
                DonMessage.error(err.message)
              })
          }
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    dianjixuanzhongXQ (row) {
      this.xuanzhongArrXQ = {}
      this.xuanzhongArrXQ = row
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 现场人员
    getUsersByTenantCodes () {
      getUsersByTenantCode()
        .then(res => {
          this.ryData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型
    zidians () {
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          this.HwTypeData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 获取货物计重方式
    getWeighingMethodLists (productType) {
      getWeighingMethodList({ productType })
        .then(res => {
          if (res.length > 0) this.inWeighingMethod = res[0].inWeighingMethod
          if (res[0].inWeighingMethod == 2) {
            this.xiecheRules.weighingWeight[0].required = true
            this.xiecheRules.weighingDate[0].required = true
          } else {
            this.xiecheRules.weighingWeight[0].required = false
            this.xiecheRules.weighingDate[0].required = false
          }
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 过磅
    weighClick () {
      if (this.detailsData.length == 0) {
        this.$message({ message: '暂无数据', type: 'error' })
      } else if (this.xuanzhongArr.primaryCustomerName == '' && this.xuanzhongArr.customerName == '') {
        this.$message.error('请先完善信息')
      } else {
        this.outstockId = this.xuanzhongArr.outstockId
        this.GBoutstockPlateNumber = this.xuanzhongArr.outstockPlateNumber
        getEmptyWeightInfoListForOutstockId({
          outstockId: this.outstockId
        })
          .then(res => {
            if (res.length == 0) {
              this.$message.error('暂无需要过磅的数据')
            } else {
              this.weighVisible = true
            }
          })
          .catch(err => {
            DonMessage.error(err.message)
          })
      }
    },
    // 合磅
    heBangClick () {
      if (this.detailsData.length == 0) {
        this.$message({ message: '暂无数据', type: 'error' })
      } else if (this.xuanzhongArr.primaryCustomerName == '' && this.xuanzhongArr.customerName == '') {
        this.$message.error('请先完善信息')
      } else {
        this.heBangVisible = true
        this.outstockId = this.xuanzhongArr.outstockId
        this.GBoutstockPlateNumber = this.xuanzhongArr.outstockPlateNumber
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yycCKPlan')
    this.getRelationCustomerS()
    this.getVirtualBalingLists()
    this.chaxun()
    this.zidians()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.chaxun()
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 175 + 'px'
    this.detailsH = 0.4 * pH - h2 - 80 + 'px'
  }
}
</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}

.ruKuZuoyeWarp {
  width: 100%;
  position: relative;
}

</style>
